import React, { useState, useEffect } from "react";
import { useModuleAccess, usePagination } from "../../../hooks";
import {
  Backdrop,
  Button,
  LogoLoader,
  NewTab,
  NewTableAdv,
  PageTabAdv,
  showToast,
  TableAdv,
} from "../../../components";
//import { mapTableRows } from "../../../utils";
import { mapTableRows } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchKultFetchStart } from "../../../redux/slices/ats/benchSales/benchSalesSlice";
//import { totalCountStart } from "../../../redux/slices/totalCount/totalCountSlice";
import { totalCountStart } from "../../../redux/slices/totalCount/totalCountSlice";
import JobsData from "../Jobs/jobsData";
import PostConfigs from "./Posts";
import PostData from "./PostData";
//import JobsData from "../../Ats/BenchSales/Jobs/jobsData";
// import JobsData from "./jobsData";

const PostsBenchsales = () => {
  const PostsMenus = [
    {
      title: "Configs",
      page: <PostConfigs />,
      type: "main",
      id: "benchsalesposts_configs",
    },
    {
      title: "Posts",
      page: <PostData />,
      type: "main",
      id: "benchsalesposts_configs",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: PostsMenus,
    parentId: "benchsalesposts",
    accessKey: "benchsales",
  });
  return (
    <div className="flex-1 flex overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="posts"
      />
    </div>
  );
};

export default PostsBenchsales;
